import Classnames from 'classnames'
import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil'
import {
  isBuilder,
  screen,
  screenOpen,
  editSectionId,
  editSectionWrapperId,
} from '@/store/builder/store'
import { RiSettings5Line } from 'react-icons/ri'
import { FaAsterisk } from 'react-icons/fa'

function HeadlineSection({ id, contentID, sectionData, wrapperId }) {
  const isBuilderApp = useRecoilValue(isBuilder)
  const [getSreen, setScreen] = useRecoilState(screen)
  const [getScreenOpen, setScreenOpen] = useRecoilState(screenOpen)
  const [getEditSectionId, setEditSectionId] = useRecoilState(editSectionId)
  const [getEditSectionWrapperId, setEditSectionWrapperId] =
    useRecoilState(editSectionWrapperId)

  return (
    <div
      className={Classnames(
        'boxHeadline bg-no-repeat relative  w-full h-full overflow-hidden flex flex-col justify-center',
        {}
      )}
      style={{
        paddingTop: sectionData.data.main_vert_padding
          ? sectionData.data.main_vert_padding + '%'
          : '0%',
        paddingBottom: sectionData.data.main_vert_padding
          ? sectionData.data.main_vert_padding + '%'
          : '0%',
      }}
    >
      {/* edit icon */}
      {isBuilderApp && (
        <div
          onClick={() => {
            setScreen('editsection')
            setScreenOpen(true)
            setEditSectionId(id)
            setEditSectionWrapperId(wrapperId)
          }}
          className="absolute top-2 right-3 opacity-50 hover:opacity-100 hover:shadow p-1 text-lg rounded  hover:bg-blue-500 hover:text-white cursor-pointer"
        >
          <RiSettings5Line />
        </div>
      )}

      {sectionData.data.mainheadline && (
        <h2
          className="block leading-snug text-center font-bold"
          style={{
            fontSize: sectionData.data.mainheadline_size
              ? sectionData.data.mainheadline_size + 'px'
              : '24px',
            marginBottom: sectionData.data.mainheadline_margin_bottom
              ? sectionData.data.mainheadline_margin_bottom + 'px'
              : '15px',
          }}
        >
          {sectionData.data.mainheadline}
        </h2>
      )}

      <a
        href={sectionData.link}
        target={sectionData.target || '_blank'}
        className={Classnames(
          'titleText p-6 rounded bg-gray-200 font-bold leading-tight block',
          {
            'items-center': sectionData.data.align == 'center',
            'text-center': sectionData.data.align == 'center',
            'items-end': sectionData.data.align == 'right',
            'text-right': sectionData.data.align == 'right',
            'hover-effect-scale': sectionData.data.hover == 'scale',
            'hover-effect-scalelarge': sectionData.data.hover == 'scalelarge',
            'hover-effect-moveup': sectionData.data.hover == 'moveup',
          }
        )}
        style={{
          borderRadius: sectionData.data.border_radius
            ? sectionData.data.border_radius + 'px'
            : '0',
          borderWidth: sectionData.data.border_size
            ? sectionData.data.border_size + 'px'
            : '0',
          borderStyle: sectionData.data.border_style
            ? sectionData.data.border_style
            : 'solid',
          borderColor: sectionData.button_border_color
            ? sectionData.button_border_color
            : '#000',
          backgroundColor: sectionData.button_background_color
            ? sectionData.button_background_color
            : '#fff',
          paddingTop: sectionData.data.vert_padding
            ? sectionData.data.vert_padding + '%'
            : '0%',
          paddingBottom: sectionData.data.vert_padding
            ? sectionData.data.vert_padding + '%'
            : '0%',
          paddingLeft: sectionData.data.horz_padding
            ? sectionData.data.horz_padding + '%'
            : '0%',
          paddingRight: sectionData.data.horz_padding
            ? sectionData.data.horz_padding + '%'
            : '0%',
          width: sectionData.data.width ? sectionData.data.width : '100%',
          margin: sectionData.data.width === 'auto' ? '0 auto' : '0',
        }}
      >
        <span
          className="block"
          style={{
            fontSize: sectionData.data.headline_size
              ? sectionData.data.headline_size + 'px'
              : '36px',
            color: sectionData.title_color ? sectionData.title_color : '#000',
          }}
        >
          {sectionData.title}
        </span>

        {sectionData.prompt && (
          <span
            className="block"
            style={{
              color: sectionData.subtitle_color
                ? sectionData.subtitle_color
                : '#000',
              fontSize: sectionData.data.subtitle_size
                ? sectionData.data.subtitle_size + 'px'
                : '18px',
              lineHeight: sectionData.data.subtitle_lineheight
                ? sectionData.data.subtitle_lineheight + 'px'
                : 'auto',
              marginLeft: sectionData.data.subtitle_side_padding
                ? sectionData.data.subtitle_side_padding + '%'
                : '0%',
              marginRight: sectionData.data.subtitle_side_padding
                ? sectionData.data.subtitle_side_padding + '%'
                : '0%',
              marginTop: sectionData.data.margin_top_subtitle
                ? sectionData.data.margin_top_subtitle + '%'
                : '0%',
            }}
          >
            {sectionData.prompt}
          </span>
        )}
      </a>

      {sectionData.data.subtitle && (
        <div
          className="block text-center shortTextInputSubtitle mt-5 text-sm opacity-75 mt-4"
          style={{
            width: sectionData.data.width ? sectionData.data.width : '100%',
            margin: '15px auto',
          }}
        >
          <div className="inline-block mr-2 mt-1 text-xs opacity-40 shortTextAnswerAster">
            <FaAsterisk />
          </div>
          <div className="inline-block font-medium">
            {sectionData.data.subtitle}
          </div>
        </div>
      )}
    </div>
  )
}

export default HeadlineSection
